/**
 * Health monitor for service availability
 */
import { getLogger } from '@qwickapps/logging';
const log = getLogger('QwickForge.MiddlewareClient.HealthMonitor');
export class HealthMonitor {
    httpClient;
    checkIntervalMs;
    status = {
        isReachable: true,
        consecutiveFailures: 0,
    };
    interval = null;
    isChecking = false;
    constructor(httpClient, checkIntervalMs = 30000) {
        this.httpClient = httpClient;
        this.checkIntervalMs = checkIntervalMs;
        log.debug('HealthMonitor initialized', { checkIntervalMs });
    }
    /**
     * Start health monitoring
     */
    start() {
        if (this.interval) {
            log.debug('Health monitoring already started');
            return;
        }
        log.debug('Starting health monitoring');
        // Periodic health checks
        this.interval = setInterval(() => {
            this.check().catch(err => {
                log.error('Health check error', { error: err });
            });
        }, this.checkIntervalMs);
        // Initial check
        this.check().catch(err => {
            log.warn('Initial health check failed', { error: err });
        });
    }
    /**
     * Stop health monitoring
     */
    stop() {
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
            log.debug('Health monitoring stopped');
        }
    }
    /**
     * Perform health check
     */
    async check() {
        if (this.isChecking) {
            return;
        }
        this.isChecking = true;
        const startTime = Date.now();
        try {
            await this.httpClient.get('/health');
            const latencyMs = Date.now() - startTime;
            const wasDown = !this.status.isReachable;
            this.status = {
                isReachable: true,
                lastSuccessfulRequest: new Date(),
                consecutiveFailures: 0,
                latencyMs,
            };
            if (wasDown) {
                log.info('Service connection restored', { latencyMs });
            }
            else {
                log.debug('Service health check OK', { latencyMs });
            }
        }
        catch (error) {
            this.status.consecutiveFailures++;
            this.status.lastFailedRequest = new Date();
            const wasUp = this.status.isReachable;
            this.status.isReachable = false;
            if (wasUp) {
                log.error('Service connection lost', {
                    error: error instanceof Error ? error.message : String(error),
                });
            }
            else {
                log.warn('Service still unreachable', {
                    consecutiveFailures: this.status.consecutiveFailures,
                });
            }
        }
        finally {
            this.isChecking = false;
        }
    }
    /**
     * Get current health status
     */
    getStatus() {
        return { ...this.status };
    }
    /**
     * Force a health check
     */
    async forceCheck() {
        await this.check();
        return this.getStatus();
    }
}
//# sourceMappingURL=HealthMonitor.js.map